import React from 'react';
import PropTypes from 'prop-types';

const NoProfessionalsAlt = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M12 13c2.762 0 5-2.238 5-5 0-2.763-2.238-5-5-5S7 5.237 7 8c0 2.762 2.238 5 5 5Zm4-5c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4Zm-1.482 5.937L13 18.272V18l-.287-2.01a.5.5 0 0 0 .382-.369l.25-1A.5.5 0 0 0 12.86 14h-1.719a.498.498 0 0 0-.485.621l.25 1a.5.5 0 0 0 .382.368l-.281 1.966-1.527-4.023-.01-.022a.74.74 0 0 0-.838-.396c-.17.042-.358.086-.557.133-.468.109-.997.232-1.498.372-.707.197-1.439.445-1.947.779C3.693 15.413 3 16.227 3 17.25V21h18v-3.75c0-1.023-.693-1.838-1.63-2.452-.508-.334-1.24-.582-1.947-.779a37.602 37.602 0 0 0-1.497-.373 66.232 66.232 0 0 1-.558-.132.74.74 0 0 0-.837.396l-.014.027Zm1.204.689-.356-.084L13.454 20H20v-2.75c0-.523-.352-1.073-1.178-1.616-.367-.242-.965-.457-1.666-.652a35.452 35.452 0 0 0-1.434-.356Zm-7.081-.085L10.713 20H4v-2.75c0-.523.352-1.073 1.178-1.616.367-.242.966-.457 1.667-.652.475-.128.952-.247 1.433-.356l.363-.085Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeWidth={0.8}
      d="M7.5 8c2.363-.394 4.416-1.719 5.181-2.263a.435.435 0 0 1 .576.067c.296.338.798.878 1.243 1.196.683.488 2 1 2 1"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.373}
      fill={color}
      stroke="#fff"
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.373)"
    />
  </svg>
);

NoProfessionalsAlt.propTypes = {
  color: PropTypes.string
};

export default NoProfessionalsAlt;
